import { useRequest } from 'ahooks'

import { queryDictItemsApi } from '@eastcoal/api/system/dict/queryDictItems'

import { AuctionCode } from '@eastcoal/shared/enums/AuctionCode'

export const PropertyRightRender = ({ value }: { value?: string }) => {
  const { data } = useRequest(
    () =>
      queryDictItemsApi(
        { code: AuctionCode.HOUSE_PROPERTY_RIGHT },
        { silence: true }
      ),
    {
      manual: false,
      ready: !!value
    }
  )
  const label = data?.find(dict => dict.val === value)?.label

  return `${label ?? '-'} 年`
}
